// ADR-0006 D4: locale resolution — explicit user choice in localStorage first,
// then `navigator.language` prefix match against LOCALES, then `en`.

import { DEFAULT_LOCALE, LOCALES, type Locale } from "../types/i18n";

const STORAGE_KEY = "calicool.locale";

export function detectLocale(): Locale {
  if (typeof window === "undefined") return DEFAULT_LOCALE;
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored && (LOCALES as readonly string[]).includes(stored)) {
      return stored as Locale;
    }
  } catch {
    /* localStorage may be blocked */
  }
  const nav = window.navigator?.language?.toLowerCase() ?? "";
  if (nav.startsWith("de")) return "de";
  if (nav.startsWith("hu")) return "hu";
  if (nav.startsWith("en")) return "en";
  return DEFAULT_LOCALE;
}

export function persistLocale(locale: Locale): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(STORAGE_KEY, locale);
  } catch {
    /* ignore */
  }
}
